import moment from "moment";
import apis from "../../../../api";
import { downloadFile } from "../../../../utils/downloadFile";
import { errorTypes } from "../../../../utils/errorTypes";
import loaders from "../../actionCreators/loadersActionCreator";
import { setErrorHandler } from "../errorActionHandler";

export const getUsersListCSVActionHandler = () => async (dispatch) => {
  // dispatch(loaders.admin.userManagement.getCountryListLoader(true));
  return await apis.admin.userManagement
    .getUsersListCSV()
    .then((response) => {
      const fileName = `ExportAllUsers_${moment().format("DMMMYYYY_hhmmss")}`;
      downloadFile(response.data, fileName);
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
  // .finally(() => {
  //   dispatch(loaders.admin.userManagement.getCountryListLoader(false));
  // });
};

export const getSearchUsersActionHandler =
  (
    searchText,
    pageNumber,
    pageSize,
    setUsersData,
    setTempUsersData,
    setTotalRows
  ) =>
  async () => {
    await apis.admin.userManagement
      .getSearchUsers(searchText, pageNumber, pageSize)
      .then((response) => {
        const updatedUserData = response?.data?.Users?.map((user) => {
          return { ...user, checked: user?.Isactive };
        });
        setUsersData((prevStateData) => [...prevStateData, ...updatedUserData]);
        setTempUsersData((prevStateData) => [
          ...prevStateData,
          ...updatedUserData,
        ]);
        setTotalRows(response.data.TotalRows);
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getUsersStatusActionHandler = () => async () => {
  return await apis.admin.userManagement
    .getUsersStatus()
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const isLoginIdExistsActionHandler = (loginId) => async (dispatch) => {
  dispatch(loaders.admin.userManagement.isLoginIdExistsLoader(true));
  let tenantName = localStorage.getItem("tenantName");
  return await apis.admin.userManagement
    .isLoginIdExists(loginId, tenantName)
    .then((response) => {
      dispatch(loaders.admin.userManagement.isLoginIdExistsLoader(false));
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const unlockUserAccountActionHandler = (id) => async (dispatch) => {
  dispatch(loaders.admin.userManagement.unlockUserAccountLoader(id));
  let data = { userId: id };
  return await apis.admin.userManagement
    .unlockUserAccount(data)
    .then((response) => {
      if (response.data) {
        dispatch(
          setErrorHandler(errorTypes.SUCCESS, "User unlocked successfully")
        );
      }
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      dispatch(loaders.admin.userManagement.unlockUserAccountLoader(false));
    });
};

export const toggleUserStatusActionHandler =
  (userId, userStatus) => async (dispatch) => {
    dispatch(loaders.admin.userManagement.toggleUserStatusLoader(userId));
    let data = [userId];
    let statusObj = {
      ACTIVE: "A",
      DEACTIVE: "D",
    };
    let status = userStatus ? statusObj.DEACTIVE : statusObj.ACTIVE;
    return await apis.admin.userManagement
      .toggleUserStatus(data, status)
      .then((response) => {
        if (response.data) {
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              `User successfully ${userStatus ? "deactivated" : "activated"}`
            )
          );
        }
        return response.data;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.admin.userManagement.toggleUserStatusLoader(false));
      });
  };

export const getCountryListActionHandler = () => async (dispatch) => {
  dispatch(loaders.admin.userManagement.getCountryListLoader(true));
  return await apis.admin.userManagement
    .getCountryList()
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      dispatch(loaders.admin.userManagement.getCountryListLoader(false));
    });
};

export const getStateListActionHandler = (countryId) => async (dispatch) => {
  dispatch(loaders.admin.userManagement.getStateListLoader(true));
  return await apis.admin.userManagement
    .getStateList(countryId)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      dispatch(loaders.admin.userManagement.getStateListLoader(false));
    });
};

export const getCityListActionHandler = (stateId) => async (dispatch) => {
  dispatch(loaders.admin.userManagement.getCityListLoader(true));
  return await apis.admin.userManagement
    .getCityList(stateId)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      dispatch(loaders.admin.userManagement.getCityListLoader(false));
    });
};

export const getWorkOfficeListActionHandler = (cityId) => async (dispatch) => {
  dispatch(loaders.admin.userManagement.getWorkOfficeListLoader(true));
  return await apis.admin.userManagement
    .getWorkOfficeList(cityId)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      dispatch(loaders.admin.userManagement.getWorkOfficeListLoader(false));
    });
};

export const getProductCategoryListActionHandler = () => async (dispatch) => {
  dispatch(loaders.admin.userManagement.getProductCategoryListLoader(true));
  return await apis.admin.userManagement
    .getProductCategoryList()
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      dispatch(
        loaders.admin.userManagement.getProductCategoryListLoader(false)
      );
    });
};

export const getUserGroupsActionHandler = () => async (dispatch) => {
  dispatch(loaders.admin.userManagement.getUserGroupsLoader(true));
  return await apis.admin.userManagement
    .getUserGroups()
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      dispatch(loaders.admin.userManagement.getUserGroupsLoader(false));
    });
};

export const getAllRolesActionHandler = () => async (dispatch) => {
  dispatch(loaders.admin.userManagement.getAllRolesLoader(true));
  return await apis.admin.userManagement
    .getAllRoles()
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      dispatch(loaders.admin.userManagement.getAllRolesLoader(false));
    });
};

export const postUserProfileActionHandler = (data) => async (dispatch) => {
  dispatch(loaders.admin.userManagement.postUserProfileLoader(true));
  return await apis.admin.userManagement
    .postUserProfile(data)
    .then((response) => {
      if (response.data) {
        dispatch(
          setErrorHandler(
            errorTypes.SUCCESS,
            `${data?.FirstName} ${data?.MiddleName} ${data?.LastName} user is successfully created.`
          )
        );
      }
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      dispatch(loaders.admin.userManagement.postUserProfileLoader(false));
    });
};

export const getUserProfileActionHandler = (userId) => async (dispatch) => {
  dispatch(loaders.common.pageLoader(true));
  return await apis.admin.userManagement
    .getUserProfile(userId)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      dispatch(loaders.common.pageLoader(false));
    });
};
export const getUserGroupsByUserIdActionHandler =
  (userId) => async (dispatch) => {
    dispatch(loaders.common.pageLoader(true));
    return await apis.admin.userManagement
      .getUserGroupsByUserId(userId)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.common.pageLoader(false));
      });
  };

export const putUserProfileActionHandler = (data) => async (dispatch) => {
  dispatch(loaders.admin.userManagement.putUserProfileLoader(true));
  return await apis.admin.userManagement
    .putUserProfile(data)
    .then((response) => {
      if (response.data) {
        dispatch(
          setErrorHandler(
            errorTypes.SUCCESS,
            `${data?.FirstName} ${data?.LastName} user is successfully updated.`
          )
        );
      }
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      dispatch(loaders.admin.userManagement.putUserProfileLoader(false));
    });
};

export const getDomainNamesActionHandler = () => async () => {
  return await apis.admin.organizationSettings.getDomainNames().then((response) => {
    if(response){
      return response
    }
  }).catch((err) => {
    console.log(err)
  })
}
